import { useUmsatzAbsatzZiele } from '@/domain/controlling/hooks';
import { getHoursAndMinutesFromMinutes } from '@/utils';
import { t } from 'i18next';
import { useParams } from 'react-router-dom';
import { LabeledField } from './LabeledField';
import { LabeledTimeField } from './LabeledTimeField';
import { useTagebuchEinstellungen } from '@/domain/controlling/hooks/useTagebuchEinstellungen';
import { AbsatzVorgabe } from '@/domain/controlling/entities';
import {
  formatNumber,
  getAbsatzProduktivitaetByMptOrStueck,
} from '../../utils';
import { ZieleError } from './ZieleError';
import { useStandortContext } from '@/features/standortContext/StandortContext';

export function AbsatzZiele() {
  const { year, month } = useParams();
  const jahr = parseInt(year);
  const monat = parseInt(month);

  const {
    currentStandort: { id: standortId },
  } = useStandortContext();
  const { absatzZiel, error } = useUmsatzAbsatzZiele(standortId, jahr, monat);
  const { tagebuchEinstellungen } = useTagebuchEinstellungen(standortId);

  return !error ? (
    <div className="flex flex-row px-5 py-4 justify-between">
      <LabeledField
        className="w-1/3"
        value={
          absatzZiel.wert
            ? formatNumber(absatzZiel.wert.toString(), true)
            : undefined
        }
        label={t('domain.controlling.umsatzplanung.ziele.absatz')}
        currency={t('domain.controlling.umsatzplanung.units.stueck')}
      />
      <LabeledField
        className="w-1/3"
        value={getAbsatzProduktivitaetByMptOrStueck(
          absatzZiel.produktivitaet,
          tagebuchEinstellungen.absatzProduktivitaet,
        )}
        label={t('domain.controlling.umsatzplanung.ziele.produktivitaet')}
        currency={
          tagebuchEinstellungen.absatzProduktivitaet.absatzVorgabe ===
          AbsatzVorgabe.Stueck
            ? t('domain.controlling.umsatzplanung.ziele.Stk./Std.')
            : t('domain.controlling.umsatzplanung.ziele.mpt')
        }
      />
      <LabeledTimeField
        className="w-1/3 border-l border-neutrals-300 pl-4"
        label={t('domain.controlling.umsatzplanung.ziele.zielstunden')}
        hours={getHoursAndMinutesFromMinutes(absatzZiel.stunden).hours}
        minutes={getHoursAndMinutesFromMinutes(absatzZiel.stunden).minutes}
      />
    </div>
  ) : (
    <div className="px-5 py-4">
      <ZieleError />
    </div>
  );
}
